import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";
import { useDispatch, useSelector } from 'react-redux';
import PageBreadcrumb from "../common/PageBreadCrumb";
import PageMeta from "../common/PageMeta";
import ComponentCard from "../common/ComponentCard";
import Label from "../form/Label";
import Input from "../form/input/InputField";
import TextArea from "../form/input/TextArea";
import Select from "../form/Select";
import Button from "../ui/button/Button";
import Alert from "../../components/ui/alert/Alert";
import { CheckLineIcon, CloseLineIcon, EyeCloseIcon, EyeIcon } from "../../icons";
import { getWhatsappSettings, updateWhatsappSettings } from "../../actions/settingAction";
import { checkAuth, emptyReduxUser } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';


export default function EditWhatsapp() {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [isActive, setActive] = useState(false);

  const getWhatsappSettingsRes = useSelector(state => state.userReducer.getWhatsappSettings);
  const getWhatsappSettingsFailed = useSelector(state => state.userReducer.getWhatsappSettingsFailed);

  const updateWhatsappSettingsRes = useSelector(state => state.userReducer.updateWhatsappSettings);
  const updateWhatsappSettingsFailed = useSelector(state => state.userReducer.updateWhatsappSettingsFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);


  const [accesstoken, setAccesstoken] = useState("");
  const [errorAccesstoken, setErrorAccesstoken] = useState(false);

  const [phonenumberid, setPhoneNumberId] = useState("");
  const [errorPhoneNumberId, setErrorPhoneNumberId] = useState(false);

  const [businessid, setBusinessId] = useState("");
  const [errorBusinessId, setErrorBusinessId] = useState(false);

  var calls = 1;

  useEffect(() => {
    calls++;
    dispatch(checkAuth());
    dispatch(getWhatsappSettings());
  }, []);
 
  useEffect(() => {

    if(checkAuthFailed.statusCode == 401){
      dispatch(emptyReduxUser());
      logout();
      navigate("/signin");
    }

  }, [checkAuthFailed]);

  useEffect(() => {

    if(typeof getWhatsappSettingsRes != "undefined" && getWhatsappSettingsRes.statusCode == 200){

      let data = getWhatsappSettingsRes.data;

      setAccesstoken(data.accesstoken);
      setPhoneNumberId(data.phonenumberid);
      setBusinessId(data.businessid);

    }

  }, [getWhatsappSettingsRes]);

  useEffect(() => {

    if(typeof updateWhatsappSettingsRes != "undefined" && updateWhatsappSettingsRes.statusCode == 200){

      setShowSuccessAlert(true);

      setTimeout(()=>{
        setShowSuccessAlert(false);
      },2500);

      setActive(false);

    }

  }, [updateWhatsappSettingsRes]);

  const handleChangeNew = (input, event) => {
    
    var value = (input == "accesstoken") ? event : event.target.value;

    if(input == "accesstoken"){
      setAccesstoken(value);
    }

    if(input == "phonenumberid"){
      setPhoneNumberId(value);
    }

    if(input == "businessid"){
      setBusinessId(value);
    }
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    setErrorAccesstoken(false);
    setErrorPhoneNumberId(false);
    setErrorBusinessId(false);

    var err = [];

    if(accesstoken.replace(/\s/g, '') == ""){
      err.push("Accesstoken");
      setErrorAccesstoken(true);
    }
    if(phonenumberid.replace(/\s/g, '') == ""){
      err.push("PhoneNumberId");
      setErrorPhoneNumberId(true);
    }
    if(businessid.replace(/\s/g, '') == ""){
      err.push("BusinessId");
      setErrorBusinessId(true);
    }
    
    if(err.length === 0){
        let data = {
          "accesstoken" : accesstoken,
          "phonenumberid" : phonenumberid,
          "businessid" : businessid,
        };
        dispatch(updateWhatsappSettings(data, 1));
    } else {
      toast.error("Invalid data. Please fill all the fields properly.", {position: "bottom-right", autoClose:4000});
    }
  };

  const resetForm = (e) => {
      e.preventDefault();

      setAccesstoken("");
      setErrorAccesstoken(false);
      setPhoneNumberId("");
      setErrorPhoneNumberId(false);
      setBusinessId("");
      setErrorBusinessId(false);
  }
  
  return (        
    <div>
      <PageMeta
        title="Whatsapp Settings | Chit Fund Management System"
        description="Whatsapp Settings info - Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Settings" />
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">

        <div className="space-y-9">
          <ComponentCard title="Whatsapp info">
            {(
              showSuccessAlert 

              ? 
              <Alert
                variant="success"
                title="Done!"
                message="Whatsapp info successfully updated."
                showLink={false}
              />

              : 
              
              null
            )}
            <form onSubmit={handleSubmit} className='fadein'>
              <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">
                <div className="space-y-6">
                  
                  <div>
                    <Label>Access Token</Label>
                    <TextArea 
                      placeholder="Enter the access token" 
                      error={errorAccesstoken}
                      value={accesstoken} 
                      onChange={(e) => handleChangeNew("accesstoken", e)} 
                      hint={errorAccesstoken ? "This field is required." : ""} 
                    />
                  </div>

                  <div>
                    <Label>Phone Number Id</Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Phone Number Id" 
                      error={errorPhoneNumberId}
                      value={phonenumberid} 
                      onChange={(e) => handleChangeNew("phonenumberid", e)} 
                      hint={errorPhoneNumberId ? "This field is required." : ""} 
                    />
                  </div>

                  <div>
                    <Label>Businees Id</Label>
                    <Input 
                      type="text" 
                      placeholder="Enter the Businees Id" 
                      error={errorBusinessId}
                      value={businessid} 
                      onChange={(e) => handleChangeNew("businessid", e)} 
                      hint={errorBusinessId ? "This field is required." : ""} 
                    />
                  </div>

                </div>

                <div className="space-x-6">
                  <Button size="sm" variant="primary" startIcon={<CheckLineIcon />}>
                    Submit
                  </Button>
                  <Button size="sm" onClick={resetForm} variant="outline" startIcon={<CloseLineIcon />}>
                    Cancel
                  </Button>
                </div>

              </div>
            </form>
          </ComponentCard>
        </div>

      </div>
    </div>
  );
}
